export const getRandomNumber = (max = 100) => Math.round(Math.random() * max);
